module.exports = __webpack_public_path__ + "static/img/img_1.f9913d54.jpg";